import React, { Fragment, Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import axios from './axios/axios';
import Footer from './containers/components/footer/Footer';
import Nav from './containers/components/header/Nav';
import Logo from './containers/components/header/Logo'
import LangSwitcher from './containers/components/header/langSwitcher/LangSwitcher';
import Main from './containers/components/main/Main';
import News from './containers/components/news/News';
import Calculator from './containers/components/calculator/Calculator';
import Faqs from './containers/components/questions/Faqs'
import AboutSystem from './containers/components/aboutSystem/AboutSystem';
import Partners from './containers/components/partners/Partners';
import TransferState from './containers/components/transferState/TransferState';
import Maps from './containers/components/map/Maps';
import Tariffs from './containers/components/tariffs/Tariffs';
import ScrollToTop from './helpers/ScrollToTop';
import { setStaticDefaultContentAction } from './actions/setStaticDefaultContentAction';
import { setStaticActiveLangContentAction } from './actions/setStaticActiveLangContentAction';

class App extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (!localStorage.getItem('activeLang')) {
      this.getStaticDefaultContent();
    } else {
      this.getAllContent();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeLang !== prevProps.activeLang) {
      this.getStaticActiveLangContent();
    }
  }

  getStaticDefaultContent = () => {
    axios.defaults.headers.isocode = 'uk';
    axios.get(`api/welsend/public/getPageElementsStaticContent`)
      .then(res => this.props.setStaticDefaultContentAction(res.data))
      .catch((error => {
        console.log(error);
      }))
  }

  getStaticActiveLangContent = () => {
    axios.get(`api/welsend/public/getPageElementsStaticContent`, {
      headers: {
        isocode: this.props.activeLang
      }
    })
      .then(res => this.props.setStaticActiveLangContentAction(res.data))
      .catch((error => {
        console.log(error);
      }))
  }

  getAllContent = () => {
    let promises = [];
    const promiseDefaultContent = axios.get(`api/welsend/public/getPageElementsStaticContent`);
    const promiseActiveLangContent = axios.get(`api/welsend/public/getPageElementsStaticContent`, {
      headers: {
        isocode: this.props.activeLang
      }
    });
    promises = [promiseDefaultContent, promiseActiveLangContent]
    Promise.all(promises).then(res => {
      if (res[0].status === 200 && res[1].status === 200) {
        this.props.setStaticDefaultContentAction(res[0].data, res[1].data)
      }
    })
      .catch((error) => console.log(error))
  }

  render() {
    return (
      <BrowserRouter>
        <div className="app">
          <div className='header-wrapper'>
            <header className='header'>
              <Nav defaultStaticContent={this.props.defaultStaticContent.navLinks}
                activeLangStaticContent={this.props.activeLangStaticContent.navLinks} />
              <Logo />
              <LangSwitcher />
            </header>
          </div>
          <Fragment>
            <ScrollToTop />
            <Switch>
              <Route path='/' exact
                render={(props) => (
                  <Main
                    {...props}
                    activeLang={this.props.activeLang}
                    defaultStaticContentNav={this.props.defaultStaticContent.navLinks}
                    activeLangStaticContentNav={this.props.activeLangStaticContent.navLinks}
                    defaultStaticContentMainPage={this.props.defaultStaticContent.mainPage}
                    activeLangStaticContentMainPage={this.props.activeLangStaticContent.mainPage}
                    defaultStaticContentNews={this.props.defaultStaticContent.news}
                    activeLangStaticContentNews={this.props.activeLangStaticContent.news}
                    defaultStaticContentPartners={this.props.defaultStaticContent.partners}
                    activeLangStaticContentPartners={this.props.activeLangStaticContent.partners} />
                )}
              />
              <Route path='/calculator'
                render={(props) => (
                  <Calculator {...props}
                    defaultStaticContentNav={this.props.defaultStaticContent.navLinks}
                    activeLangStaticContentNav={this.props.activeLangStaticContent.navLinks}
                    defaultStaticContentCalc={this.props.defaultStaticContent.transferCount}
                    activeLangStaticContentCalc={this.props.activeLangStaticContent.transferCount}
                    defaultStaticContentSend={this.props.defaultStaticContent.transferSend}
                    activeLangStaticContentSend={this.props.activeLangStaticContent.transferSend}
                  />
                )}
              />
              <Route path='/faqs'
                render={() => (
                  <Faqs
                    defaultStaticContentFaqs={this.props.defaultStaticContent.navLinks}
                    activeLangStaticContentFaqs={this.props.activeLangStaticContent.navLinks}
                  />
                )}
              />
              <Route path='/news'
                render={() => (
                  <News
                    activeLang={this.props.activeLang}
                    defaultStaticContentNews={this.props.defaultStaticContent.news}
                    activeLangStaticContentNews={this.props.activeLangStaticContent.news}
                  />
                )}
              />
              <Route path='/aboutSystem'
                render={() => (
                  <AboutSystem
                    defaultStaticContentAboutSystem={this.props.defaultStaticContent.aboutSystem}
                    activeLangStaticContentAboutSystem={this.props.activeLangStaticContent.aboutSystem}
                  />
                )}
              />
              <Route path='/partners'
                render={(props) => (
                  <Partners {...props}
                    defaultStaticContentPartners={this.props.defaultStaticContent.partners}
                    activeLangStaticContentPartners={this.props.activeLangStaticContent.partners}
                    defaultStaticContentFeedBack={this.props.defaultStaticContent.feedBack}
                    activeLangStaticContentFeedBack={this.props.activeLangStaticContent.feedBack}
                  />
                )}
              />
              <Route path='/transferState'
                render={(props) => (
                  <TransferState {...props}
                    defaultStaticContentTransferInfo={this.props.defaultStaticContent.transferInfo}
                    activeLangStaticContentTransferInfo={this.props.activeLangStaticContent.transferInfo}
                    defaultStaticContentTransferState={this.props.defaultStaticContent.transferState}
                    activeLangStaticContentTransferState={this.props.activeLangStaticContent.transferState}
                  />
                )}
              />
              <Route path='/maps'
                render={() => (
                  <Maps
                    defaultStaticContentMap={this.props.defaultStaticContent.map}
                    activeLangStaticContentMap={this.props.activeLangStaticContent.map}
                  />
                )}
              />
              <Route path='/tariffs'
                render={(props) => (
                  <Tariffs {...props}
                    defaultStaticContentTariffs={this.props.defaultStaticContent.tariffs}
                    activeLangStaticContentTariffs={this.props.activeLangStaticContent.tariffs}
                  />
                )}
              />
            </Switch>
          </Fragment>
        </div>
        <Footer defaultStaticContent={this.props.defaultStaticContent.footer}
          defaultStaticContentNav={this.props.defaultStaticContent.navLinks}
          activeLangStaticContent={this.props.activeLangStaticContent.footer}
          activeLangStaticContentNav={this.props.activeLangStaticContent.navLinks} />
      </BrowserRouter>
    )
  }
}

const mapStateToProps = state => ({
  activeLang: state.lang.activeLang,
  defaultStaticContent: state.lang.defaultStaticContent,
  activeLangStaticContent: state.lang.activeLangStaticContent,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setStaticDefaultContentAction,
  setStaticActiveLangContentAction
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

App.propTypes = {
  activeLang: PropTypes.string.isRequired,
  setStaticDefaultContentAction: PropTypes.func.isRequired,
  setStaticActiveLangContentAction: PropTypes.func.isRequired,
  defaultStaticContent: PropTypes.object.isRequired,
  activeLangStaticContent: PropTypes.object.isRequired,
}

